export const VALIDATION_IDENTIFIERS = {
  NOT_VALID: -1,
  VALID: 1,
  DONT_CHECK: 0,
  TOO_SHORT: 'too_short',
  BLANK: 'blank',
  CONFIRM: 'confirm',
};
